import { Center, Spinner, VStack, Text } from '@chakra-ui/react';
import type { CenterProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface PageSpinnerProps extends Omit<CenterProps, 'children'> {
    /** Spinner size */
    size?: 'sm' | 'md' | 'lg' | 'xl';
    /** Optional loading message to display below spinner */
    message?: ReactNode;
}

/**
 * Centered loading spinner for page/section loading states.
 * Use this for async data loading in page sections.
 */
export function PageSpinner({ size = 'xl', h = '50vh', message, ...props }: PageSpinnerProps) {
    return (
        <Center h={h} {...props}>
            {message ? (
                <VStack gap={3}>
                    <Spinner size={size} />
                    <Text fontSize={{ base: 'md', md: 'lg' }}>{message}</Text>
                </VStack>
            ) : (
                <Spinner size={size} />
            )}
        </Center>
    );
}
